import type { OcsPatchEntryInput, WriteOcsSettingsResult } from 'owa-graph-schema';
import { lazyWriteOcsSettings } from 'owa-ocs-service-gql';
import { getAccountScopeUserSettings } from 'owa-session-store';
import { QUICK_STEPS_SETTING_NAME } from '../constants';
import type { MailboxInfo } from 'owa-client-types';
import { logUsage } from 'owa-analytics';

export default function saveQuickStepsToService(
    mailboxInfo: MailboxInfo,
    valueToSave: string
): Promise<WriteOcsSettingsResult | undefined> {
    const ocsQuickStepsPatch: OcsPatchEntryInput = {
        name: QUICK_STEPS_SETTING_NAME,
        value: valueToSave,
        type: 'JSON',
        scope: getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress || '',
        itemClass: 'RoamingSetting',
    };

    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logUsage('QS_Import_SaveToServiceCalled', undefined);
    return lazyWriteOcsSettings.importAndExecute(
        mailboxInfo,
        'ACCOUNT',
        [ocsQuickStepsPatch],
        'setMailQuickSteps' /* actionName */
    );
}
